import dayjs from 'dayjs';
import { DateTime, type Interval } from 'luxon';

export function dateDifferenceReminder(
  date1: string,
  date2: string,
  precision: string,
) {
  const firstDate = DateTime.fromISO(dayjs(date1).format('YYYY-MM-DD')).startOf(
    'day',
  );
  const secondDate = DateTime.fromISO(dayjs(date2).format('YYYY-MM-DD'))
    .startOf('day')
    .plus({ days: 1 });

  const diffDuration = (firstDate.until(secondDate) as Interval<true>)
    .toDuration(['years', 'months', 'days'])
    .toObject();

  switch (precision) {
    case 'anni':
    case 'anno':
      return diffDuration.years ?? 0;
    case 'mesi':
    case 'mese':
      return diffDuration.months ?? 0;
    case 'giorni':
    case 'giorno':
      return diffDuration.days ?? 0;
    default:
      return 0;
  }
}
